<template>
    <main>
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="page-heading">
                        <h2>Download the <span>Game</span></h2>
                        <p>Exiles is currently LIVE! Join our <a href="https://discord.com/invite/3yt9kXRdax" target="_blank">Discord</a> for assistance.</p>
                        <p>The Windows Installer comes bundled with java.</p>
                        <p>The <span>.jar</span> client should have functionality across all OS, if you have Java 11.</p>
                    </div>
                </div>
            </div>
            <div class="main-content-box">
            <h3 class="page-title center">Choose a client</h3>
                <div class="download--grid">
                    <div class="col">
                        <div class="card h-100 mb-0 download-box--current-os">
                            <div class="download-box">
                                <h5 class="content-box--heading">Windows Launcher<br>With Java 11</h5>
                                <p>
                                    <small>
                                        .exe | 28MB
                                    </small>
                                </p>
                                <i class="fab fa-windows download-box--icon"></i>
                                <a href="https://exiles-ps.com/play/ExilesSetup.exe" target="_blank" class="btn full-width download-box--link" file>
                                    WINDOWS LAUNCHER
                                </a>
                                <hr>
                                <h6>Supports:</h6>
                                <ul>
                                    <li class="card p-1 mb-1 shadow-none">Windows 11</li>
                                    <li class="card p-1 mb-1 shadow-none">Windows 10</li>
                                    <li class="card p-1 mb-1 shadow-none">Windows 8</li>
                                    <li class="card p-1 mb-0 shadow-none">Windows 7</li>
                                </ul><br>
                                <h6>Other Installers:</h6>
                                <ul>
                                    <li class="card p-1 mb-1 shadow-none"><a href="https://exiles-ps.com/play/ExilesSetupARM64.exe" target="_blank">Download .exe for ARM64<i class="fas fa-link ml-1"></i></a></li>
                                </ul>
                            </div>
                        </div>


                    </div>
                    <div class="col">
                        <div class="card h-100 mb-0">
                            <div class="download-box">
                                <h5 class="content-box--heading">JAR Launcher<br>Without Java 11</h5>
                                <p>
                                    <small>
                                        .jar | 2.5MB
                                    </small>
                                </p>
                                <i class="fab fa-java download-box--icon"></i>
                                <a href="https://exiles-ps.com/play/Exiles.jar" target="_blank" class="btn full-width download-box--link" file>
                                    JAR LAUNCHER
                                </a>
                                <hr>
                                <h6>Requires:</h6>
                                <ul>
                                    <li class="card p-1 mb-1 shadow-none">Requires Java 11 installed on your system.</li>
                                    <li class="card p-1 mb-1 shadow-none"><a href="https://www.oracle.com/java/technologies/javase/jdk11-archive-downloads.html" target="_blank">Download Java 11<i class="fas fa-link ml-1"></i></a></li>
                                    <li class="card p-1 mb-1 shadow-none">Download JARFIX if you've never ran a .jar</li>
                                    <li class="card p-1 mb-1 shadow-none"><a href="https://johann.loefflmann.net/downloads/jarfix.exe" target="_blank">Download JARFIX<i class="fas fa-link ml-1"></i></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="card h-100 mb-0">
                            <div class="download-box">
                                <h5 class="content-box--heading">JAR Launcher<br>For All OS</h5>
                                <p>
                                    <small>
                                        .jar | 2.5MB
                                    </small>
                                </p>
                                <i class="fab fa-apple download-box--icon"></i>
                                <a href="https://exiles-ps.com/play/Exiles.jar" target="_blank" class="btn full-width download-box--link" file>
                                    JAR LAUNCHER FOR ALL OS
                                </a>
                                <hr>
                                <h6>Requires:</h6>
                                <ul>
                                    <li class="card p-1 mb-1 shadow-none">Requires Java 11 installed on your system.</li>
                                    <li class="card p-1 mb-1 shadow-none"><a href="https://www.oracle.com/java/technologies/javase/jdk11-archive-downloads.html" target="_blank">Download Java 11<i class="fas fa-link ml-1"></i></a></li>
                                </ul><br>
                                <h6>Other Installers:</h6>
                                <ul>
                                    <li class="card p-1 mb-1 shadow-none"><a href="https://exiles-ps.com/play/Exiles.dmg" target="_blank">Download DMG Launcher<i class="fas fa-link ml-1"></i></a></li>
                                    <li class="card p-1 mb-1 shadow-none"><a href="https://exiles-ps.com/play/ExilesARM64.dmg" target="_blank">Download DMG ARM64 Launcher<i class="fas fa-link ml-1"></i></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
export default {
    created() {
        document.title = 'Exiles'
    }
}
</script>
